"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = require("react");
var i18nContext_1 = tslib_1.__importDefault(require("./i18nContext"));
/**
 * A hook to consume the current locale.
 *
 * @returns The current active locale.
 */
var useLocale = function () {
    var locale = react_1.useContext(i18nContext_1.default).locale;
    return locale;
};
exports.default = useLocale;
